export default "__VITE_PUBLIC_ASSET__a4374eb3__"